module.exports = __webpack_public_path__ + "media/images/new_home/sean_mccloud-22d98ac76ee755537e40c0db8929ffde.png";